<template>
    <div class="file-upload-list-wrapper">
        <ul class="file-list">
            <li v-if="sessionFiles.length > 0" class="session-file">
                <ul class="session-files">
                    <file-list v-for="file in getSessionFiles" :key="file.name" :file="file" :bus="bus"></file-list>
                </ul>
            </li>
            <file-list v-for="file in files" :key="file.name" :file="file" :container="container" :folderPath="folderPath" :bus="bus"></file-list>
        </ul>
    </div>
</template>

<script>
    import fileUiComponent from './port-fileupload-file-list.vue';

    export default {
        props: ["files", "sessionFiles", "container", "folderPath", "bus"],
        computed: {
            getSessionFiles: function() {
                this.sessionFiles.map(function(sf) {
                    // reset Progress
                    sf.progress = 0;
                    return sf;
                });
                return this.sessionFiles;
            }
        },
        components: {
            "file-list": fileUiComponent
        }
    }
</script>